import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import WidgetFilterDropdown from "./widgetFilterDropdown";
import WidgetFilterCheckbox from "./widgetFilterCheckbox";
import PositionedDialog from "./positionedDialog";

const WidgetTile = ({
  title,
  viewMoreRoute,
  bodyContent,
  enableFilter = false,
  filterConfig,
}) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {/* Title + Actions */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingBottom: "10px",
          ...(enableFilter
            ? { gap: "12px" }
            : { justifyContent: "space-between" }),
        }}
      >
        {/* Title + Filter */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            ...(enableFilter ? { width: "100%" } : {}),
          }}
        >
          <span
            style={{
              fontSize: "var(--card-title-font-size)",
              color: "var(--card-primary-color)",
              fontWeight: "var(--font-weight-medium)",
            }}
          >
            {title}
          </span>

          {enableFilter &&
            (filterConfig.type === "checkbox" ? (
              <button
                ref={anchorRef}
                onClick={() => setFilterOpen(true)}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
                title="Open Filters"
              >
                ⚙️
              </button>
            ) : (
              <WidgetFilterDropdown
                value={filterConfig.value}
                valueChange={filterConfig.handleChange}
                dropDownList={filterConfig.options}
              />
            ))}
        </div>

        {/* View More */}
        <Link
          to={viewMoreRoute}
          title="View More"
          style={{
            color: "var(--card-secondary-color)",
            fontSize: "var(--card-action-font-size)",
            textDecoration: "none",
            minWidth: "80px",
            textAlign: "center",
          }}
        >
          View More →
        </Link>
      </div>

      {/* Body */}
      <div>{bodyContent}</div>

      {/* Filter Dialog (if enabled) */}
      {enableFilter && (
        <PositionedDialog
          anchorRef={anchorRef}
          open={filterOpen}
          close={() => setFilterOpen(false)}
          bodyContent={
            <WidgetFilterCheckbox
              checkboxList={filterConfig.options}
              checkedObj={filterConfig.value}
              onFilterChange={filterConfig.handleChange}
              onApplyFilter={() => {
                setFilterOpen(false);
                filterConfig.handleApply();
              }}
              onResetFilter={() => {
                setFilterOpen(false);
                filterConfig.handleReset();
              }}
            />
          }
        />
      )}
    </div>
  );
};

export default WidgetTile;
